// @react/hooks/useDocumentDocumentType.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { documentDocumentTypeStore } from '@core/stores';

/**
 * React hook for DocumentTypeDefinition operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useDocumentDocumentType } from '@react/hooks';
 *
 * const DocumentTypeDefinitionList = observer(() => {
 *   const store = useDocumentDocumentType();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useDocumentDocumentType() {
  return documentDocumentTypeStore;
}
